import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { classNames } from './utils';
export default function FieldTitle({ title, htmlFor, titlePosition, className, }) {
    const titleElem = title ? (_jsx("label", { htmlFor: htmlFor, className: classNames('font-inter dark:text-text-secondary font-medium whitespace-nowrap text-gray-700', titlePosition === 'overlapping'
            ? 'bg-card absolute -top-2 left-2 z-10 inline-block px-1 text-xs'
            : 'block text-sm leading-5', className), children: title })) : (_jsx(_Fragment, {}));
    return titleElem;
}
